import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';

export const useOrderManagementApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getAllOrders = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        // Only include search parameter if it has a value
        const searchParam =
          query.search && query.search.trim() !== '' ? query.search : undefined;
        const response = await api.getAllOrders(
          query.userType,
          query.userId,
          undefined,
          query.page,
          query.limit,
          // query.merchantId,
          query.orderId,
          undefined,
          query.status,
          query.fromDate,
          query.toDate,
          query.sortBy,
          query.sortOrder,
          searchParam
        );
        return response;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  return {
    getAllOrders,
    loading,
    error,
  };
};
